import LanguageSelector from '../i18n/LanguageSelector';
import { useAppTranslation } from '../i18n/useAppTranslation';
import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Container, Paper, TextField, Typography } from '@mui/material';
import { publicApi } from '../services/api';

export default function ConfirmEmail() {
  const { tr } = useAppTranslation();
  const [params] = useSearchParams();
  const token = params.get('token');
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const submit = async (action: 'confirm' | 'resend') => {
    setBusy(true); setError(''); setMessage('');
    try {
      const response = await publicApi.post(action === 'confirm' ? '/users/confirm-email/' : '/users/resend-confirmation/', action === 'confirm' ? { token } : { email });
      setMessage(response.data.detail);
      if (action === 'confirm') setConfirmed(true);
    } catch (err: any) {
      const data = err.response?.data;
      setError(String(data?.error || data?.email || data?.detail || 'Impossible de traiter la demande. Veuillez réessayer.'));
    } finally { setBusy(false); }
  };
  return <Container maxWidth="sm" sx={{ py: 6 }}><Paper sx={{ p: { xs: 3, sm: 5 }, borderRadius: 4 }}>
<LanguageSelector/>

    <Typography variant="h4" component="h1" gutterBottom>{tr("Confirmer mon adresse e-mail")}</Typography>
    <Typography color="text.secondary" sx={{ mb: 3 }}>{tr("La confirmation de votre adresse active votre compte Sportif ou Coach.")}</Typography>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{typeof error === 'string' ? tr(error) : error}</Alert>}
    {message && <Alert severity="success" sx={{ mb: 2 }}>{tr(message)}</Alert>}
    {token && !confirmed && <Button fullWidth variant="contained" disabled={busy} onClick={() => submit('confirm')} sx={{ mb: 3 }}>{tr("Confirmer mon adresse")}</Button>}
    {!confirmed && <Box component="form" onSubmit={event => { event.preventDefault(); submit('resend'); }}>
      <Typography variant="body2">{tr("Lien absent ou expiré ? Recevez un nouvel e-mail de confirmation (valable 24 heures).")}</Typography>
      <TextField label={tr("Adresse e-mail")} type="email" autoComplete="email" required fullWidth margin="normal" value={email} onChange={event => setEmail(event.target.value)} />
      <Button type="submit" variant="outlined" fullWidth disabled={busy}>{tr("Renvoyer le lien de confirmation")}</Button>
    </Box>}
    <Button component={Link} to="/login" fullWidth sx={{ mt: 2 }}>{tr("Se connecter")}</Button>
  </Paper></Container>;
}
